// extracted by mini-css-extract-plugin
export default {"fltTableOuter":"flights_fltTableOuter__CFkV0","days":"flights_days__HBlnM"};